import type {AccountType} from '@/types';

export const getAccountTypeLabels = (accountType: AccountType) => {
    if (accountType === 'business') {
        return {
            organizationSingular: 'Tier 1',
            organizationPlural: 'Tier 1s',
            accountSingular: 'Tier 2',
            accountPlural: 'Tier 2s',
            hostSingular: 'Game Host',
            hostPlural: 'Game Hosts',
        };
    }

    // Default to academic labels
    return {
        organizationSingular: 'District',
        organizationPlural: 'Districts',
        accountSingular: 'School',
        accountPlural: 'Schools',
        hostSingular: 'Game Host',
        hostPlural: 'Game Hosts',
    };
};
